'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PERMISSIONS = exports.ROLES = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROLES = exports.ROLES = (0, _keymirror2.default)({
  LIBRARY_PATRON: null,
  LIBRARY_STAFF: null,
  SYS_ADMIN: null
});

var PERMISSIONS = exports.PERMISSIONS = (0, _keymirror2.default)({
  SYSTEM_MESSAGE: null,
  USER_TAKEOVER: null,
  EMAIL_TEMPLATES: null,
  REPORT_FEEDBACK: null,
  UGC_FREE_TEXT: null
});

exports.default = {
  ROLES: ROLES,
  PERMISSIONS: PERMISSIONS
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/constants-user/lib/index.js
// module id = 1406
// module chunks = 1